export default __webpack_public_path__ + "static/media/login_bg.2c205f80.png";